<template>
    <div v-if="element"
         :class="{uploaded: upload}"
         class="canvas-element">
        {{ {status} }}
        {{ element.name }}
    </div>
</template>

<script>
import API from "@/API";

export default {
    name: "CanvasElement",
    props: ['elementId', 'item', 'status'],

    data(){
        return {
            element: null,
        }
    },


    computed: {

        canvas_data(){
            return this.item?.canvas_data;
        },

        upload(){
            return this.canvas_data?.upload;
        },

    },

    async mounted() {
        this.element = await API.elements.get( this.elementId );
    }

}
</script>

<style lang="scss" scoped>
.canvas-element{
    position: relative;
    background: darken($light, 3%);
    border: white solid 2px;
    border-radius: 0.3rem;
    padding: 0.6rem 0.8rem 0.6rem 2rem;
    box-shadow: rgba($dark, 0.1) 0 3px 5px;
    margin-bottom: 0.6rem;

    &.uploaded{
        background: lighten($success, 30%);

        &:before{
            content: '✓';
            position: absolute;
            left: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>
